import { render } from "./formularioAltaTarjeta.vue?vue&type=template&id=10e6728d"
import script from "./formularioAltaTarjeta.vue?vue&type=script&lang=js"
export * from "./formularioAltaTarjeta.vue?vue&type=script&lang=js"

import "./formularioAltaTarjeta.vue?vue&type=style&index=0&id=10e6728d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__